import script from "./TaoNavPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TaoNavPanel.vue?vue&type=script&setup=true&lang=js"

import "./TaoNavPanel.vue?vue&type=style&index=0&id=21a5a6b0&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21a5a6b0"]])

export default __exports__